/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

import { switchMap, first } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromPaymentMethodsActions, paymentMethodsQuery, PaymentMethodsState } from '../../+state';

/**
 * Gets Cards for manage-payment screen
 */
@Injectable()
export class CardsResolver {
  constructor(private _store: Store<PaymentMethodsState>) {}

  /*
   * Resolve Cards
   * 1. Selects getCards from the store
   * 3. Check if Cards is present
   * - If state is empty:
   *   1. Call getCards
   * 4. Return Cards from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(paymentMethodsQuery.getCards).pipe(
      switchMap(cards => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getCards();
        return of(cards);

        // if (!cards) {
        //   this.getCards();
        // }
        // return of(cards);
      }),
      first()
    );
  }

  /*
   * trigger fetching Cards
   * 1. Dispatch getPaymentMethods action
   */
  private getCards() {
    this._store.dispatch(fromPaymentMethodsActions.getCards());
  }
}
